module.exports = __webpack_public_path__ + "static/media/icon-check-badge.46b226f3.svg";